import camelcase from 'camelcase';
import decamelize from 'decamelize';

import { CamelCaseObject, SnakeCaseObject } from '@/types/case';

/**
 * Transform object keys to camelCase.
 * TODO: test this function.
 * @param data Object to transform.
 * @returns Object with camelCase keys.
 */
export const camelCaseObject = <T>(data: T): CamelCaseObject<T> => {
  if (Array.isArray(data)) {
    return data.map(item =>
      typeof item === 'object'
        ? camelCaseObject(item as Record<string, unknown>)
        : item,
    ) as CamelCaseObject<T>;
  }
  return Object.entries(data).reduce(
    (acc, [key, value]) => {
      if (typeof key === 'string') {
        const newKey = camelcase(key as string);
        acc[newKey] =
          typeof value === 'object'
            ? camelCaseObject(value as Record<string, unknown>)
            : value;
      }
      return acc;
    },
    {} as Record<string, unknown>,
  ) as CamelCaseObject<T>;
};

/**
 * Transform object keys to snake_case.
 * TODO: test this function.
 * @param data Object to transform.
 * @returns Object with snake_case keys.
 */
export const decamelizeObject = <T extends Record<string, unknown>>(
  data: T,
): SnakeCaseObject<T> => {
  return Object.entries(data).reduce(
    (acc, [key, value]) => {
      if (typeof key === 'string') {
        const newKey = decamelize(key as string);
        acc[newKey] =
          typeof value === 'object'
            ? decamelizeObject(value as Record<string, unknown>)
            : value;
      }
      return acc;
    },
    {} as Record<string, unknown>,
  ) as SnakeCaseObject<T>;
};
